import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Add Customer
  isAddingCustomer: false,
  addCustomerSuccess: null,
  addCustomerError: null,
  // Update Customer Active Status
  isUpdatingCustomerActive: false,
  updateCustomerActiveSuccess: null,
  updateCustomerActiveError: null,
  // Update Customer (edit)
  isUpdatingCustomer: false,
  updateCustomerSuccess: null,
  updateCustomerError: null,
  // Delete Customer
  isDeletingCustomer: false,
  deleteCustomerSuccess: null,
  deleteCustomerError: null,
  // Get Customer Org Accounts
  isFetchingCustomerOrgAccounts: false,
  customerOrgAccountsSuccess: null,
  customerOrgAccountsError: null,
};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    // Add Customer
    addCustomer: (state) => {
      state.isAddingCustomer = true;
      state.addCustomerSuccess = null;
      state.addCustomerError = null;
    },
    addCustomerSuccess: (state, action) => {
      state.isAddingCustomer = false;
      state.addCustomerSuccess = action.payload;
      state.addCustomerError = null;
    },
    addCustomerFailure: (state, action) => {
      state.isAddingCustomer = false;
      state.addCustomerError = action.payload;
    },
    // Update Customer Active Status
    updateCustomerActive: (state) => {
      state.isUpdatingCustomerActive = true;
      state.updateCustomerActiveSuccess = null;
      state.updateCustomerActiveError = null;
    },
    updateCustomerActiveSuccess: (state, action) => {
      state.isUpdatingCustomerActive = false;
      state.updateCustomerActiveSuccess = action.payload;
      state.updateCustomerActiveError = null;
    },
    updateCustomerActiveFailure: (state, action) => {
      state.isUpdatingCustomerActive = false;
      state.updateCustomerActiveError = action.payload;
    },
    // Update Customer (edit)
    updateCustomer: (state) => {
      state.isUpdatingCustomer = true;
      state.updateCustomerSuccess = null;
      state.updateCustomerError = null;
    },
    updateCustomerSuccess: (state, action) => {
      state.isUpdatingCustomer = false;
      state.updateCustomerSuccess = action.payload;
      state.updateCustomerError = null;
    },
    updateCustomerFailure: (state, action) => {
      state.isUpdatingCustomer = false;
      state.updateCustomerError = action.payload;
    },
    // Delete Customer
    deleteCustomer: (state) => {
      state.isDeletingCustomer = true;
      state.deleteCustomerSuccess = null;
      state.deleteCustomerError = null;
    },
    deleteCustomerSuccess: (state, action) => {
      state.isDeletingCustomer = false;
      state.deleteCustomerSuccess = action.payload;
      state.deleteCustomerError = null;
    },
    deleteCustomerFailure: (state, action) => {
      state.isDeletingCustomer = false;
      state.deleteCustomerError = action.payload;
    },
    // Get Customer Org Accounts
    getCustomerOrgAccounts: (state) => {
      state.isFetchingCustomerOrgAccounts = true;
      state.customerOrgAccountsSuccess = null;
      state.customerOrgAccountsError = null;
    },
    getCustomerOrgAccountsSuccess: (state, action) => {
      state.isFetchingCustomerOrgAccounts = false;
      state.customerOrgAccountsSuccess = action.payload;
      state.customerOrgAccountsError = null;
    },
    getCustomerOrgAccountsFailure: (state, action) => {
      state.isFetchingCustomerOrgAccounts = false;
      state.customerOrgAccountsError = action.payload;
    },
    /** Clears add/delete toasts only. Does not clear loaded org accounts — dismissing an error after a failed Add Customer must not wipe the account list. */
    clearCustomerMessages: (state) => {
      state.addCustomerSuccess = null;
      state.addCustomerError = null;
      state.updateCustomerActiveSuccess = null;
      state.updateCustomerActiveError = null;
      state.updateCustomerSuccess = null;
      state.updateCustomerError = null;
      state.deleteCustomerSuccess = null;
      state.deleteCustomerError = null;
    },
    resetCustomerOrgAccounts: (state) => {
      state.isFetchingCustomerOrgAccounts = false;
      state.customerOrgAccountsSuccess = null;
      state.customerOrgAccountsError = null;
    },
  },
});

export const {
  addCustomer,
  addCustomerSuccess,
  addCustomerFailure,
  updateCustomerActive,
  updateCustomerActiveSuccess,
  updateCustomerActiveFailure,
  updateCustomer,
  updateCustomerSuccess,
  updateCustomerFailure,
  deleteCustomer,
  deleteCustomerSuccess,
  deleteCustomerFailure,
  getCustomerOrgAccounts,
  getCustomerOrgAccountsSuccess,
  getCustomerOrgAccountsFailure,
  clearCustomerMessages,
  resetCustomerOrgAccounts,
} = customerSlice.actions;

export default customerSlice.reducer;
